var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message", class: { "message--show": _vm.show } },
    [
      _vm.hasClose
        ? _c(
            "div",
            { staticClass: "message__close", on: { click: _vm.close } },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._m(1),
      _c("div", { staticClass: "message__title" }, [_vm._t("title")], 2),
      _c("div", { staticClass: "message__message" }, [_vm._t("message")], 2),
      _c("div", { staticClass: "message__field" }, [_vm._t("field")], 2),
      _c("div", { staticClass: "message__action" }, [_vm._t("action")], 2)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "icon-close" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message__icon" }, [
      _c("i", { staticClass: "icon-bliss" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-747a4443", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747a4443","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message-view.vue
// module id = 425
// module chunks = 21